<svg width="48" height="28" viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="48" height="28" rx="4" fill="#FFFFFF" />
  <circle cx="24" cy="14" r="5" fill="#FF6000" />
  <text
    x="24"
    y="17.5"
    fill="#13294B"
    font-size="6.8"
    font-weight="900"
    font-family="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
    letter-spacing="0.4"
    text-anchor="middle"
  >
    DISC<tspan fill="#FF6000">O</tspan>VER
  </text>
</svg>
